import getCamera from 'services/configurator/canvas/getCamera';
import getControls from 'services/configurator/canvas/getControls';
import getRaycaster from 'services/configurator/canvas/getRaycaster';
import getScene from 'services/configurator/canvas/getScene';
import initCanvas from 'services/configurator/canvas/initCanvas';
import setEnviroment from 'services/configurator/canvas/setEnvironment';

import ISettings from './canvas/ISettings';
import setupZoom from './canvas/setupZoom';
import getMouse from './canvas/getMouse';

const setupConfigurator = ({
  canvasRef,
  status,
}: {
  canvasRef: any;
  status: any;
}): ISettings => {
  const camera = getCamera();
  const raycaster = getRaycaster();
  const scene = getScene();
  const mouse = getMouse();

  const renderer = initCanvas({
    canvasRef,
    camera,
  });

  const controls = getControls(camera, renderer);

  window.initMasterAssembly(scene, camera, controls, raycaster, true);

  setupZoom({
    canvasRef,
    camera,
    controls,
    renderer,
    scene,
  });

  setEnviroment({
    camera,
    controls,
    scene,
    status,
  });

  function onMouseMove(event: any) {
    event.preventDefault();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  }
  document.addEventListener('mousemove', onMouseMove, false);

  function animate() {
    requestAnimationFrame(animate);
    window.HighlightObjects(raycaster, mouse, camera, scene);
  }
  animate();

  return {
    camera,
    controls,
    raycaster,
    renderer,
    scene,
  };
};

export default setupConfigurator;
